/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseWorkingModeApplyResponseData } from './genericApiResponseWorkingModeApplyResponseData';
import type { GenericApiResponseWorkingModeApplyResponseMessage } from './genericApiResponseWorkingModeApplyResponseMessage';
import type { GenericApiResponseWorkingModeApplyResponsePagination } from './genericApiResponseWorkingModeApplyResponsePagination';
import type { GenericApiResponseWorkingModeApplyResponseError } from './genericApiResponseWorkingModeApplyResponseError';

export interface GenericApiResponseWorkingModeApplyResponse {
  data?: GenericApiResponseWorkingModeApplyResponseData;
  message?: GenericApiResponseWorkingModeApplyResponseMessage;
  pagination?: GenericApiResponseWorkingModeApplyResponsePagination;
  error?: GenericApiResponseWorkingModeApplyResponseError;
  statusCode?: number;
}
